import * as React from 'react';
import { InverseBgContext } from './InverseBgContext';
import * as Classes from '../common/classes';
import classNames from 'classnames';

export function useInverseBg(componentInverse?: boolean) {
  const context = React.useContext(InverseBgContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeContext');
  }

  return componentInverse === undefined ? context.inverse : componentInverse;
}

export const getInverseBgClass = (parentInverse?: boolean) => {
  return classNames({
    [Classes.INVERSE_CONTAINER_TRUE]: parentInverse,
    [Classes.INVERSE_CONTAINER_FALSE]: !parentInverse,
  });
};
